import React from 'react';
import { Link } from 'react-router-dom';
import useSectionViewTracking from '../hooks/useSectionViewTracking';
import styles from './InceptumConceptSection.module.css';

export default function InceptumConceptSection() {
  const sectionRef = useSectionViewTracking('inceptum_concept');

  return (
    <section ref={sectionRef} className={styles.concept} id="concept">
      <div className={styles.container}>
        <h2 className={styles.title}>The INCEPTUM Concept</h2>
        <div className={styles.divider} aria-hidden="true"></div>
        <p className={styles.text}>
          <strong>INCEPTUM</strong> is a strategy series built around the great undertakings that shape the course of human history. Each title begins at the dawn of a transformative age, placing players in the position to shape how that era unfolds.
        </p>
        <p className={styles.text}>
          While each game explores a different chapter of civilization, from dawn of civilization to industry to commerce, they share a common design philosophy: meaningful trade-offs, long-term planning, and irreversible decisions. The core principles at the heart of <Link to="/inceptum" className={styles.inlineLink}>INCEPTUM: Dawn of Civilizations</Link>.
        </p>

        <div className={styles.seriesSection}>
          <h3 className={styles.seriesHeading}>The INCEPTUM Series</h3>

          <div className={styles.timelineWrapper}>
            <div className={styles.timelineLine} aria-hidden="true" />

            <div className={styles.timelineEntries}>
              <div className={styles.timelineEntry}>
                <div className={styles.nodeCurrent} aria-hidden="true" />
                <span className={styles.entryTitle}>Dawn of Civilizations</span>
                <span className={styles.entryStatus}>Current Title</span>
              </div>
              <div className={styles.timelineEntry}>
                <div className={styles.nodeFuture} aria-hidden="true" />
                <span className={styles.entryTitleFuture}>Industrial Revolution</span>
              </div>
              <div className={styles.timelineEntry}>
                <div className={styles.nodeFuture} aria-hidden="true" />
                <span className={styles.entryTitleFuture}>Parks &amp; Profits</span>
              </div>
              <div className={styles.timelineTail} aria-hidden="true">
                <span className={styles.tailDots}>&hellip;</span>
              </div>
            </div>
          </div>
        </div>

        <p className={styles.text}>
          Together, they form a growing platform of strategy experiences, each offering a distinct lens on how civilizations evolve over time.
        </p>
      </div>
    </section>
  );
}
